import { render, staticRenderFns } from "./BaseButtonV2.vue?vue&type=template&id=39cb7904&scoped=true&"
import script from "./BaseButtonV2.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseButtonV2.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseButtonV2.vue?vue&type=style&index=0&id=39cb7904&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cb7904",
  null
  
)

export default component.exports